import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Shd_Home from './shd/home.js';
import Shd_Bas from './shd/bas.js';
import Shd_Dep from './shd/dep.js';
import Shd_Prs from './shd/prs.js';
import Shd_Week from './shd/week.js';
import {withRouter} from "../lib/react/withRouter";
import Bo_Home from "./bo/home";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Ta_Shd extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.bas = { "fid": "f06", "url": "/ta/shd/bas", "name": "Basschema", "active": false };
      po.prs = { "fid": "f06", "url": "/ta/shd/prs", "name": "Personal", "active": false };
      po.week = { "fid": "f06", "url": "/ta/shd/week", "name": "Veckoschema", "active": false };
      po.dep = { "fid": "f06", "url": "/ta/shd/dep", "name": "Avdelningar", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {

    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="bas" element={ <Shd_Bas store={this.webStore} />} />
            <Route path="prs" element={ <Shd_Prs store={this.webStore} />} />
            <Route path="week" element={ <Shd_Week store={this.webStore} />} />
            <Route path="dep" element={ <Shd_Dep store={this.webStore} />} />
            <Route path="*" element={ <Shd_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Ta_Shd);
